import clsx from 'clsx';

interface BaseProps {
  className?: string;
  children: React.ReactNode;
}

export function Card({ className, children }: BaseProps) {
  return <div className={clsx('bg-white rounded-lg shadow-md p-6', className)}>{children}</div>;
}

export function CardHeader({ className, children }: BaseProps) {
  return <div className={clsx('mb-4', className)}>{children}</div>;
}

export function CardTitle({ className, children }: BaseProps) {
  return <h3 className={clsx('text-xl font-bold text-gray-900', className)}>{children}</h3>;
}

export function CardDescription({ className, children }: BaseProps) {
  return <p className={clsx('text-sm text-gray-600', className)}>{children}</p>;
}

export function CardContent({ className, children }: BaseProps) {
  return <div className={clsx('mb-4', className)}>{children}</div>;
}
